import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/logo1.png";
import { TiSocialFacebookCircular } from "react-icons/ti";
import { RxTwitterLogo } from "react-icons/rx";
import { AiOutlineInstagram, AiOutlineLinkedin } from "react-icons/ai";

const Footer = () => {
  return (
    <FooterMain>
      <FooterGrid>
        <FooterCard>
          <img src={logo} alt="" className="logo" />
          <p>
            Let's Build Your <br /> Buisness with money manager
          </p>
          <Link to="#" className="joinNow">
            Join Now
          </Link>
        </FooterCard>
        <FooterCard>
          <h3>Company</h3>
          <ul>
            <li>
              <Link to="#">About</Link>
            </li>
            <li>
              <Link to="#">Career</Link>
            </li>
            <li>
              <Link to="#">Career Single</Link>
            </li>
            <li>
              <Link to="#">Contact</Link>
            </li>
          </ul>
        </FooterCard>
        <FooterCard>
          <h3>Resources</h3>
          <ul>
            <li>
              <Link to="#">Case Study</Link>
            </li>
            <li>
              <Link to="#">Case Study Single</Link>
            </li>
            <li>
              <Link to="#">Reviews</Link>
            </li>
            <li>
              <Link to="#">Integration</Link>
            </li>
            <li>
              <Link to="#">Integration Single</Link>
            </li>
          </ul>
        </FooterCard>
        <FooterCard>
          <h3>Essential</h3>
          <ul>
            <li>
              <Link to="#">Career</Link>
            </li>
            <li>
              <Link to="#">Faq</Link>
            </li>
            <li>
              <Link to="#">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="#">Policy</Link>
            </li>
          </ul>
        </FooterCard>
      </FooterGrid>
      <FooterSocial>
        <div>
          <a href="http://nmskaar.com/" target="_blank">
            <span>&copy; Nmskaar Infotech</span> All rights reserved.
          </a>
        </div>
        <div>
          <ul>
            <li>
              <a href="#">
                <TiSocialFacebookCircular className="iconSocial" />
              </a>
            </li>
            <li>
              <a href="#">
                <RxTwitterLogo className="iconSocial" />
              </a>
            </li>
            <li>
              <a href="#">
                <AiOutlineInstagram className="iconSocial" />
              </a>
            </li>
            <li>
              <a href="#">
                <AiOutlineLinkedin className="iconSocial" />
              </a>
            </li>
          </ul>
        </div>
      </FooterSocial>
    </FooterMain>
  );
};

export default Footer;

const FooterMain = styled.div`
  padding: 4rem calc((100vw - 1200px) / 2);
  padding-bottom: 0rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  grid-gap: 1rem;
  margin-bottom: 10px;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    margin-left: 50px;
  }
`;

const FooterCard = styled.div`
  .logo {
    width: 200px;
    height: 70px;
  }
  p {
    margin-left: 20px;
    font-weight: 500;
    font-size: 20px;
    color: #20204f;
    margin-top: 15px;
    margin-bottom: 25px;
  }
  .joinNow {
    text-decoration: none;
    margin-left: 20px;
    font-weight: 500;
    font-size: 18px;
    color: #20204f;
  }
  h3 {
    font-weight: 500;
    font-size: 19px;
    color: #20204f;
  }
  ul {
    list-style: none;
    margin-top: 15px;
    li {
      margin-bottom: 15px;
      a {
        text-decoration: none;
        color: #535353;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
  @media only screen and (max-width: 991px) {
    .logo {
      width: 200px;
      height: 70px;
      margin-left: -10px;
    }
    p {
      margin-left: 0px;
      margin-bottom: 5px;
    }
    .joinNow {
      margin-left: 0px;
    }
    ul {
      margin-top: 15px;
    }
  }
`;

const FooterSocial = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0px;
  border-top: 1.7px solid #20204f;

  div {
    a {
      color: #20204f;

      span {
        color: #000033;
        font-weight: 500;
      }
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      list-style: none;
      li {
        a {
          margin-left: 15px;
          text-decoration: none;
          .iconSocial {
            font-size: 23px;
            color: #20204f;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    padding-top: 20px;
    padding-bottom: 15px;
    div {
      p {
        color: #20204f;
        text-align: center;
        margin-bottom: 15px;

        span {
          color: #000033;
          font-weight: 500;
        }
      }
      ul {
        display: flex;
        align-items: center;
        justify-content: center;
        list-style: none;
        li {
          a {
            margin-left: 15px;
            text-decoration: none;
            .iconSocial {
              font-size: 23px;
              color: #20204f;
            }
          }
        }
      }
    }
  }
`;
